import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ModelInfoArrayEditModal from "../modals/ModelInfoArrayEditModal";
import { ArrayExtensions } from "../../extensions/ArrayExtensions";

interface ModelInfoInputFieldArrayProps {
  error?: boolean;
  columnName: string;
  allModelVariants?: boolean;
  allModelVariantsInitial?: boolean;
  initialValues: (string | number)[];
  currentValues: (string | number)[];
  onlyAllowNumbers: boolean;
  allowDecimals: boolean;
  disabled: boolean;
  onShow: (show: boolean) => void;
  onAllModelVariants?: (value: boolean) => void;
  onChangeNumberArray?: (value: number[]) => void;
  onChangeStringArray?: (value: string[], isAllModelVariant: boolean) => void;
}

function ModelInfoInputFieldArray({
  error,
  columnName,
  allModelVariants,
  allModelVariantsInitial,
  initialValues,
  currentValues,
  onlyAllowNumbers,
  allowDecimals,
  disabled,
  onShow,
  onChangeNumberArray,
  onChangeStringArray,
}: ModelInfoInputFieldArrayProps) {
  const [values, setValues] = useState(currentValues);
  const [isModified, setIsModified] = useState(false);
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
    onShow(true);
  };

  const arrayEquals = (arr1: any[], arr2: any[]): boolean => {
    return (
      arr1.length === arr2.length &&
      arr1.every((value, index) => value === arr2[index])
    );
  };

  const handleClosingModal = (
    newArray: (string | number)[],
    isAllModelVariants: boolean = false,
  ) => {
    setShow(false);
    onShow(false);
    let sortedArray = newArray;

    if (onlyAllowNumbers) {
      sortedArray = newArray.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
    } else if (!onlyAllowNumbers) {
      sortedArray = newArray.sort((a, b) =>
        a.toString().toLowerCase() < b.toString().toLowerCase()
          ? -1
          : a.toString().toLowerCase() < b.toString().toLowerCase()
            ? 1
            : 0,
      );
    }

    setValues(sortedArray);
    setIsModified(
      !arrayEquals(sortedArray, initialValues) ||
        isAllModelVariants !== allModelVariantsInitial,
    );

    if (onlyAllowNumbers) {
      const numberArray: number[] = newArray.map((item) =>
        typeof item === "string" ? parseFloat(item) : item,
      );
      if (onChangeNumberArray !== undefined) {
        onChangeNumberArray(numberArray);
      } else {
        return;
      }
    } else {
      const stringArray: string[] = newArray.map((item) => String(item));
      if (onChangeStringArray !== undefined) {
        onChangeStringArray(stringArray, isAllModelVariants);
      } else {
        return;
      }
    }
  };

  useEffect(() => {
    setValues(currentValues);
    setIsModified(
      !arrayEquals(currentValues, initialValues) ||
        allModelVariants !== allModelVariantsInitial,
    );
  }, [currentValues, initialValues, allModelVariants, allModelVariantsInitial]);

  const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
    handleShow();
  };

  return (
    <>
      <Button
        className={
          error
            ? "border-3 border-danger"
            : isModified
              ? "border-3 border-warning"
              : ""
        }
        variant="outline-secondary"
        style={{ width: "100%", maxWidth: "105px" }}
        onClick={handleSelect}
        size="sm"
      >
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "140px",
            textAlign: "center",
          }}
        >
          {allModelVariants ? (
            <span style={{ fontWeight: 650 }}>ALL</span>
          ) : values && values.length !== 0 ? (
            ArrayExtensions.toStringWithSemicolons(values)
          ) : (
            "-"
          )}
        </div>
      </Button>

      {show ? (
        <ModelInfoArrayEditModal
          isSortable={true}
          columnName={columnName}
          allModelVariant={allModelVariants}
          currentValues={values}
          onlyAllowNumbers={onlyAllowNumbers}
          allowDecimals={allowDecimals}
          disabled={disabled}
          onCancel={handleClosingModal}
        />
      ) : null}
    </>
  );
}

export default ModelInfoInputFieldArray;
